import { HttpResponseStatusCodes } from '@hobt/constants';
import { ApiClient, ApiClientConfig } from 'Foundation/Api';
import { AuthenticationContextType } from 'Foundation/Authentication';
import { config } from '../../../../../../../../config';

export type AddModifyRemarsksPayload = {
  remark: {
    remarkId: number | undefined;
    remarkText: string | undefined;
  };
};

type RequestProps = {
  authenticationContext: AuthenticationContextType;
  masterPoolNumber: number;
  payload: AddModifyRemarsksPayload;
};

const apiClientConfig: ApiClientConfig = {
  timeout: config.validationReviewInventoryApi.requestTimeout
};

const timeout: number = config.validationReviewInventoryApi.requestTimeout;

const poolInventoryDetailUrl: string =
  config.validationMasterPoolAPi.urls.masterPoolInventoryDetail;

export const overrideMasterPoolRemarks = async ({
  authenticationContext,
  masterPoolNumber,
  payload
}: RequestProps): Promise<[]> => {
  try {
    const requestQuery = `${poolInventoryDetailUrl}/${masterPoolNumber}/remark`;

    const response = await ApiClient(authenticationContext, apiClientConfig).patchWithAuth(
      requestQuery,
      payload,
      { timeout }
    );

    return (
      ((response?.data?.statusCode === HttpResponseStatusCodes.Created ||
        response?.data?.statusCode === HttpResponseStatusCodes.OK) &&
        response?.data?.data) ||
      []
    );
  } catch (err) {
    throw new Error('Error updating master pool number remarks');
  }
};
